import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePanelDashboardPosition as mutation } from "../modules/CustomDashboardModule/services/DashboardConfigurationService";

/**
 * Creates a callable method to pass in a on click
 * @param {Object} props - The module's config so this hook knows what to update and read
 * @param {function} props.selector - active tab id selector
 * @param {function} props.onLoading - loading state handler
 * @param {function} props.onError - error state handler
 * @returns {Object} That contains a function to be called in an `onClick` event
 */
export const useUpdatePanelsPositionsMutation = ({
  selector,
  onLoading,
  onError,
  onResponse,
}) => {
  const dispatch = useDispatch();
  const activeTabId = useSelector(selector);

  const updatePositions = useCallback(
    async (panelsToUpdate) => {
      // dispatch(onLoading(true));
      try {
        const body = panelsToUpdate.map((panel) => ({
          id: panel.tableId,
          xPos: panel.x,
          yPos: panel.y,
          width: panel.w,
          height: panel.h,
          panel: { id: panel.id },
          tab: { id: activeTabId },
          accountId: localStorage.getItem("u_account_id"),
        }));
        await mutation(body);
        onResponse?.(panelsToUpdate);
      } catch (error) {
        dispatch(onError(error));
      } finally {
        // dispatch(onLoading(false));
      }
    },
    [activeTabId]
  );

  return { updatePositions };
};
